import React from 'react';
import { DropdownItem } from '../../../../types';
import { AttendeeCreatorToggle } from '../AttendeeCreatorToggle/AttendeeCreatorToggle';
import { IntentToggleOptions } from '../../../../types';
import { MobileDropdown } from '../Dropdowns';
import styles from './IntentToggle.module.scss';

interface IntentToggleProps {
    activeOption: IntentToggleOptions;
    dropdownItems: DropdownItem[];
    isMobile?: boolean;
    hostEventsRedirectURL?: string;
}

export const IntentToggle: React.FC<IntentToggleProps> = ({
    activeOption,
    dropdownItems,
    isMobile = false,
    hostEventsRedirectURL,
}) => {
    const containerClass = isMobile ? styles.mobileToggleContainer : styles.toggleContainer;

    if (isMobile) {
        return (
            <div
                data-testid="intent-toggle-wrapper"
                data-variant="mobile"
                className={styles.mobileContainer}
            >
                <div data-testid="toggle-container" className={containerClass}>
                    <AttendeeCreatorToggle
                        activeOption={activeOption}
                        hostEventsRedirectURL={hostEventsRedirectURL}
                    />
                </div>
                <div data-testid="dropdown-container" className={styles.mobileDropdownContainer}>
                    <MobileDropdown dropdownItems={dropdownItems} />
                </div>
            </div>
        );
    }

    return (
        <>
            <div data-testid="toggle-container" data-variant="desktop" className={containerClass}>
                <AttendeeCreatorToggle
                    activeOption={activeOption}
                    hostEventsRedirectURL={hostEventsRedirectURL}
                />
            </div>
            <div data-testid="dropdown-container">
                <MobileDropdown dropdownItems={dropdownItems} />
            </div>
        </>
    );
};
